export default __webpack_public_path__ + "f89e78a45b605ed014a723f2dd5561ca.png";